// Tamaño lógico del carné (proporción tarjeta crédito 85.6×54 mm)
export const CARD_W = 500;
export const CARD_H = 315;

// Lista de elementos disponibles en el carné con su tipo y propiedades por defecto
export const DEFAULT_LAYOUT = {
  logo:           { type: "image",  x: 20,  y: 20,  width: 64, height: 64,  visible: true,  z: 5 },
  secondary_logo: { type: "image",  x: 416, y: 20,  width: 60, height: 60,  visible: false, z: 5 },
  club_name:      { type: "text",   x: 96,  y: 36,  fontSize: 26, weight: 800, content: "club_name",     align: "left",  visible: true,  z: 4 },
  subtitle:       { type: "text",   x: 96,  y: 22,  fontSize: 10, weight: 700, content: "card_subtitle", align: "left",  visible: true,  z: 4, letterSpacing: 3, opacity: 0.7 },
  numero_label:   { type: "text",   x: 20,  y: 102, fontSize: 9,  weight: 700, content: "static:SOCIO Nº", align: "left", visible: true,  z: 4, letterSpacing: 3, opacity: 0.7 },
  numero:         { type: "text",   x: 20,  y: 116, fontSize: 56, weight: 800, content: "numero_socio",  align: "left",  visible: true,  z: 4 },
  fullname:       { type: "text",   x: 20,  y: 188, fontSize: 20, weight: 800, content: "fullname",      align: "left",  visible: true,  z: 4 },
  dni:            { type: "text",   x: 20,  y: 216, fontSize: 12, weight: 500, content: "dni_label",     align: "left",  visible: true,  z: 4, opacity: 0.8 },
  temporada_label:{ type: "text",   x: 20,  y: 252, fontSize: 9,  weight: 700, content: "static:TEMPORADA", align: "left", visible: true, z: 4, letterSpacing: 3, opacity: 0.7 },
  temporada:      { type: "text",   x: 20,  y: 266, fontSize: 22, weight: 800, content: "temporada",     align: "left",  visible: true,  z: 4 },
  photo:          { type: "photo",  x: 200, y: 100, width: 110, height: 140, visible: false, z: 5 },
  qr:             { type: "qr",     x: 360, y: 180, size: 120,                visible: true,  z: 5 },
};

export const ELEMENT_LABELS = {
  logo:           "Logo principal",
  secondary_logo: "Logo secundario",
  club_name:      "Nombre del club",
  subtitle:       "Subtítulo",
  numero_label:   "Etiqueta «Socio Nº»",
  numero:         "Número de socio",
  fullname:       "Nombre completo",
  dni:            "DNI",
  temporada_label:"Etiqueta «Temporada»",
  temporada:      "Temporada",
  photo:          "Foto del socio",
  qr:             "Código QR",
};

// Devuelve el layout con defaults aplicados (si falta algún elemento usa default)
export function resolveLayout(savedLayout) {
  const out = {};
  for (const key of Object.keys(DEFAULT_LAYOUT)) {
    out[key] = { ...DEFAULT_LAYOUT[key], ...(savedLayout?.[key] || {}) };
  }
  return out;
}

// Resuelve qué texto mostrar para un elemento según el socio
export function resolveTextContent(el, socio, cfg) {
  if (!el.content) return "";
  if (el.content.startsWith("static:")) return el.content.slice(7);
  switch (el.content) {
    case "club_name": return cfg.club_name || "";
    case "card_subtitle": return cfg.card_subtitle || "";
    case "numero_socio": return socio.numero_socio || "";
    case "fullname": return `${socio.nombre || ""} ${socio.apellidos || ""}`.trim();
    case "dni": return socio.dni || "";
    case "dni_label": return socio.dni ? `DNI: ${socio.dni}` : "";
    case "temporada": return socio.temporada || "";
    default: return "";
  }
}
